import {
  AfterContentChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component, ElementRef,
  Input, OnChanges,
  OnDestroy,
  OnInit, TemplateRef, ViewChild,
} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Item} from '../../models/Item';
import {ItemConfig} from '../../models/ItemConfig';
import {ReplaySubject, Subscription, timer} from 'rxjs';
import {map, takeUntil, tap} from 'rxjs/operators';
import {IMG_TYPE_IMAGE, IMG_TYPE_PANOLENS} from '../../interfaces/constants';
import {GlobalEventsService} from 'src/app/services/global-events.service';
import {ImageInputService} from '@src/app/services/ImageInputService/image-input.service';
import {PaywallUserService} from '@modules/paywall/services/paywallUserService/paywall-user.service';
import {ObjectArrayPlugin} from '@src/app/classes/plugins/objectArrayPlugin/object-array-plugin';
import {ItemManagerService} from '@src/app/services/itemManager/item-manager.service';
import {CesiumAdapterService} from '@src/app/services/cesiumAdapter21/cesium-adapter.service';

declare var Yiit;

export interface ImageInputSettings {
  key: string;
  value: {
    buttonText?: string;
    static: boolean;
    showInPopup: boolean;
    type: string;
    value: string;
  };
}


@Component({
  selector: 'app-image-input',
  templateUrl: './image-input.component.html',
  styleUrls: ['./image-input.component.scss']
})
export class ImageInputComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  public Yiit = Yiit;
  public modalConfig: any = {};

  private _settings: ImageInputSettings;
  public tooltipMsg: string = null;
  public redoMsg: string = null;
  private currentItemId:number|string = Math.random();
  private subscriptions: Subscription;
  @Input()
  set setting(val: ImageInputSettings) {
    this._settings = val;
    this.updateButtonMsg(val);
  }

  get setting(): ImageInputSettings {
    return this._settings;
  }

  @ViewChild('imageFileInput', {static: false}) imageFileInput: ElementRef<HTMLInputElement>;

  get allowChangeImg(): boolean {
    return (this.setting && this.setting.value) ? !this.setting.value.static : false;
  }

  @Input() item: Item;

  private btnText = [Yiit.t('Upload File'), Yiit.t('Change Image')];
  private allowedTypes = ['png', 'jpg', 'jpeg'];
  //'gif', 'svg', 'svg+xml'
  private destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  public buttonMsg: string = null;
  public isCustomIcon: boolean = false;
  public isTwoImages:boolean = false;

  get isCopyItem(){
    return this.item.config.isCopy;
  }

  public isImageChanged(item, setting){
    return item.config.getInputProp(setting.key, 'defaultValue');
  }

  private _errorMsg: string = null;
  set errorMsg(val: string) {
    this._errorMsg = val;
    this.eventService.ToastNotificationEvent.emit({
      message: this.errorMsg,
      title: 'Image upload error',
      classes: ['error'],
      autoHide: true,
      autoHideDelay: 10000
    });
  }

  private isChanged = true;
  get errorMsg(): string | null {
    return this._errorMsg;
  }

  constructor(private http: HttpClient,
              private eventService: GlobalEventsService,
              private cd: ChangeDetectorRef,
              private iis: ImageInputService,
              private paywallS: PaywallUserService,
              private im: ItemManagerService,
              private adapter: CesiumAdapterService,
  ) {
  }

  ngOnInit(): void {
    this.subscriptions = new Subscription();
    this.isCustomIcon = (this.setting.key === 'customIcon');
    if (this.isCustomIcon){
      this.tooltipMsg = Yiit.t('Upload your own icon\n' +
        'The max. file size is 1 Mb');
      this.redoMsg = Yiit.t('Reset to default icon');
    }
    this.modalConfig.item = this.item;
    this.modalConfig.title = this.item.getTitle();
    this.modalConfig.imgType = this.setting.value.type;
    this.modalConfig.imageUrl = (
      this.setting.value.value
      && this.setting.value.value.trim().length > 0
      && this.isAllowedImg()
    ) ? this.setting.value.value : null;

    if (!this.isCustomIcon){
      this.iis.modalConfig = this.modalConfig;
    }

    this.currentItemId = this.item.getId();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  ngOnChanges(): void{

    if (this.item.getId() != this.currentItemId){

      if (this.subscriptions){
        this.subscriptions.unsubscribe();
      }
      this.subscriptions = new Subscription();
      this.currentItemId = this.item.getId();
      this.isChanged = true;
      this.isTwoImages = Object.values(this.item.config.getInputs()).filter( (input:any) => input.type && input.type === 'image').length === 2;


      this.modalConfig = {
        item: this.item,
        imageUrl: this.setting.value.value && this.setting.value.value.trim().length > 0 && this.isAllowedImg()
          ? this.setting.value.value
          : null
      };

    if (!this.isCustomIcon) {
      this.iis.modalConfig = this.modalConfig;
    }

    if (this.setting.key !== 'customIcon' && this.setting.value && this.setting.value.value) {
      this.showImageModal();
    }
    }
  }


  ngAfterViewInit(): void {
    this.initListeners();

  }

  private isAllowedImg() {
    let fileType = this.setting.value.value.toLowerCase();
    const index = fileType.lastIndexOf('.');
    fileType = fileType.substr(index + 1, fileType.length);
    return this.allowedTypes.includes(fileType);
  }

  initListeners() {
    // note: config.subject and config.serverUpdate possible do the job twice since setter already call to change btn
    if (this.isChanged) {
      this.subscriptions.add(this.item.config.subject
        .pipe(takeUntil(this.destroy$))
        .subscribe((newConfig: ItemConfig) => {
          this.processNewConfig(newConfig);
        }));

      this.subscriptions.add(this.item.config.serverUpdate
        .pipe(takeUntil(this.destroy$))
        .subscribe((newConfig: ItemConfig) => {
          this.processNewConfig(newConfig);
        }));

      if (this.setting.key !== 'customIcon') {
        this.subscriptions.add(this.item.getSubject(Item.OBJECT_CLICK)
          .pipe(takeUntil(this.destroy$))
          .subscribe((isCtrl) => {
            if (!isCtrl && this.setting.value && this.setting.value.value) {
              this.showImageModal();
            }
          }));
      }
      this.isChanged = false;
    }
  }

  private processNewConfig(newConfig: ItemConfig) {
    this.updateButtonMsg(newConfig[this.setting.key] as ImageInputSettings);
  }

  private updateButtonMsg(config: ImageInputSettings): void {
    if (!config) {
      return;
    }

    if (config.value) {
      if (!this.allowChangeImg && config.value.buttonText) {
        this.buttonMsg = (this.allowChangeImg) ? this.btnText[1] : config.value.buttonText;
      } else {
        this.buttonMsg = (config.value.value && config.value.value.trim().length > 0) ? this.btnText[1] : this.btnText[0];
      }
    }
  }

  canEditItem(item) {
    return true;
  }

  getInputProp() {
    return this.item.config.getInputProp(this.setting.key, 'value');
  }

  async uploadFile(item: Item, setting, event) {
    const filesRef = event.target.files;
    let uploadPromises = [];

    let inputs = {};
    let _currentItem = this.item.config.isCopy ? this.im.getItemById(item.config.getCopyParentId) : item;
    let allInputs = _currentItem.config.getInputs();
    for (let i in allInputs){
      let input = allInputs[i];
      if (input.type && input.type === 'image'){
        inputs[i] = input;
      }
    }

    if (filesRef.length > 2) {
      console.error({message: 'Too much files uploaded', val: null});
      this.errorMsg = 'Please upload 2 files or less.';
      event.target.value = '';
      return;
    }

    if (filesRef) {
      const files:any[] = Object.values(filesRef);
      for (let [index, f] of Object.entries(files)){
        if (files.length > 1){
          setting = {key: Object.keys(inputs)[index], value: Object.values(inputs)[index]}
        }
        let config = {f, event, setting, item: _currentItem}
        uploadPromises.push(this.processFileUpload(config));
      }

      this.updateItemConfigAndOpenModal(_currentItem, uploadPromises);
    }

    setTimeout(() => { this.adapter.viewer.scene.requestRender(); }, 500);
  }

  private setNewItemProps(promiseResults, item){
    promiseResults.forEach(({img, setting, modalConfig})=>{
      if (item.config.getInputByName(setting.key)) {
        item.config.setInputValue(setting.key, 'value', img.val);
      } else {
        item.config.createInputValue(setting.key, {
          type: 'image',
          label: 'Icon',
          value: img.val,
          defaultValue: item.config.getObjectConfig().getMapIcon(),
        });
      }
      this.iis.modalConfig = modalConfig;
    })
  }

  private updateItemConfigAndOpenModal(item, uploadPromises:Promise<any>[]){
    let items:Item[] = [item];
    if(item.config.isCopy || ObjectArrayPlugin.isItemHasObjectArray(item)){
       items = items.concat(this.im.getAllItemCopies(item));
    }
    Promise.all(uploadPromises).then((results:{setting, img, modalConfig}[])=>{
      items.forEach((_item:Item)=>{
        this.setNewItemProps(results, _item);
      })
      if (this.setting.key !== 'customIcon') {
      this.showImageModal();
      }
    })
  }

  private processFileUpload({f, event, setting, item}) {

    return new Promise((resolve, reject) => {

      if (!this.allowedTypes.includes(f.type.replace('image/', '').toLowerCase())) {
        console.error({message: 'wrong file type', val: f.type.replace('image/', '')});
        // this.errorMsg = Yiit.t('Please upload PNG or JPEG files only.');
        this.errorMsg = 'Please upload PNG or JPEG files only.';
        event.target.value = '';
        reject('Please upload PNG or JPEG files only.');
        return;

      }

      if (!f.type.match('image.*')) {
        console.error({message: 'file type not image', val: null});
        this.errorMsg = 'Please upload PNG or JPEG files only.';
        event.target.value = '';
        reject('Please upload PNG or JPEG files only.');
        return;
      }

      const reader = new FileReader();

      // Closure to capture the file information.
      if (window.hasOwnProperty('SOCKETIO_HOST')) {
        reader.onload = ((theFile) => {
          this.errorMsg = null;
          return async (e) => {
            let dataBeforeSplit = e.target.result.slice();
            const data = e.target.result.split(';base64,')[1];
            let maxSize = 2 * 1024 * 1024;
            if (this.isCustomIcon) {
              maxSize = 1048576;
            }
            if (theFile.size > maxSize) {
              this.errorMsg = 'The file size is too big and cannot be uploaded. \n' +
                'The max. file size is ' + maxSize / 1024 / 1024 + 'Mb';
              event.target.value = '';
              this.modalConfig.imageUrl = null;
              this.iis.hideModal();
              this.cd.detectChanges();
              reject('The file size is too big and cannot be uploaded. \n' +
                'The max. file size is ' + maxSize / 1024 / 1024 + 'Mb');
              return;
            }
            let promise: any = new Promise<any>((r, error) => {
              let img = new Image();
              img.onload = (e) => {
                return r({width: img.width, height: img.height});
              };
              img.src = dataBeforeSplit;
            });
            let imageResult: {width, height} = await promise;
            if (imageResult.width > 2000 || imageResult.height > 2000) {
              this.errorMsg = 'The image size is too big and cannot be uploaded. \n' +
                'The max. image size is 2000*2000 px';
              event.target.value = '';
              this.modalConfig.imageUrl = null;
              this.iis.hideModal();
              this.cd.detectChanges();
              reject('The image size is too big and cannot be uploaded. \n' +
                'The max. image size is 2000*2000 px');
              return;
            }


            let _currentItem = item.config.isCopy ? this.im.getItemById(item.config.getCopyParentId) : item;

            this.uploadDataToServer(theFile.name, data)
              .pipe(map(val => {
                  return {val: val, oldVal: _currentItem.config.getObjectConfig().getMapIcon()};
              }))
              .subscribe((resultUrl) => {
                  if(!_currentItem.config.getInputProp(setting.key, 'defaultValue') && this.isCustomIcon){
                    if (_currentItem.config.getInputByName(setting.key)) {
                      _currentItem.config.setInputValue(setting.key, 'defaultValue', resultUrl.oldVal);
                    }
                    if (this.paywallS.isUserNewFreemium()) {
                      this.paywallS.incrementChangedIconObjectsCounter();
                      if (this.paywallS.iconChangedObjectsCounter === 5) {
                        this.paywallS.openWarningModal();
                      }
                      if (this.paywallS.iconChangedObjectsCounter === 10) {
                        this.paywallS.openLastWarningModal();
                      }
                      if (this.paywallS.iconChangedObjectsCounter > 10) {
                        this.paywallS.openLastWarningModal();
                        this.paywallS.decrementChangedIconObjectsCounter();
                        if (_currentItem.config.getInputByName(setting.key)) {
                          _currentItem.config.removeInputProp(setting.key, 'defaultValue');
                        }
                        event.target.value = '';
                        this.cd.detectChanges();
                        return false;
                      }
                    }
                  }
                  this.modalConfig.imageUrl = resultUrl;
                  this.modalConfig.item = this.item;
                  this.modalConfig.title = this.item.getTitle();
                  this.cd.detectChanges();
                  // this.iis.modalConfig = this.modalConfig;
                  // this.showImageModal();
                  resolve({setting, img: resultUrl, modalConfig: this.modalConfig});
                },
                (error) => {
                  this.errorMsg = error.message;
                  event.target.value = '';
                  this.modalConfig.imageUrl = null;
                  this.iis.modalConfig = this.modalConfig;
                  this.iis.hideModal();
                  this.cd.detectChanges();
                  console.error('uploadImage to Server failed', error);
                  if (_currentItem.config.getInputByName(setting.key)) {
                    _currentItem.config.setInputValue(setting.key, 'value', '123');
                  }
                  reject(error.message);
                });

          };
        })(f);
      } else {
        reader.addEventListener('load', () => {
          // convert image file to base64 string
          const resultUrl = reader.result;

          this.modalConfig['imageUrl'] = resultUrl;
          this.modalConfig.item = this.item;
          this.modalConfig.title = this.item.getTitle();
          this.cd.detectChanges();
          resolve({setting, img: resultUrl, modalConfig: this.modalConfig});
        }, false);
      }

      reader.readAsDataURL(f);
    });
  }


  private uploadDataToServer(fileName, data) {
    const params: HttpParams = new HttpParams({
      fromObject: {
        axios_workaround: btoa(JSON.stringify({
            object_id: this.item.getId(),
            name: fileName, data
          }
        ))
      }
    });
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
    // {object_id: this.item.getId(), name: fileName, data: data}
    return this.http.request('POST', Item.URL_UPLOAD_PHOTO, {body: params, headers});
  }

  showImageModal(): void {
    this.errorMsg = null;
    this.iis.openModal();
  }

  resetToDefaultImg($event){
    $event.preventDefault();
    $event.stopPropagation();
    $event.stopImmediatePropagation();
    this.imageFileInput.nativeElement.value = '';
    let defaultImgUrl = this.item.config.getInputProp(this.setting.key, 'defaultValue');
    this.item.config.setInputValue(this.setting.key, 'value', defaultImgUrl);
    this.item.config.removeInputProp(this.setting.key, 'defaultValue');
    this.item.config.removeInput(this.setting.key);

    if (this.paywallS.isUserNewFreemium()){
      this.paywallS.decrementChangedIconObjectsCounter();
    }
  }

  isAcceptableImage(): boolean {
    return this.setting.value.hasOwnProperty('type')
      && (this.setting.value.type === IMG_TYPE_IMAGE || this.setting.value.type === IMG_TYPE_PANOLENS);
  }
}
